// extracted by mini-css-extract-plugin
export default {"icone":"ConverteParaIcone_icone__K-F5O","sizeIcone_small":"ConverteParaIcone_sizeIcone_small__yHUuf"};